<template>
  <div class="match-manage">
    <header class="page-header">
      <h2 class="page-header__title">赛事管理</h2>
      <div class="page-header__toolbar">
        <span class="switch-text">赛事菜单开关</span>
        <el-switch
          class="menu-switch"
          v-model="menuSwitch"
          on-text=""
          off-text=""
          on-color="#409EFF"
          off-color="#dcdfe6"
          :disabled="menuSwitchLoading"
          @change="handleMenuSwitchChange"
        ></el-switch>
        <span class="switch-text">开启后APP端将展示赛事列表</span>
      </div>
    </header>

    <!-- 搜索区域 -->
    <el-form :inline="true" :model="queryForm" class="search-form">
      <el-form-item label="赛事ID">
        <el-input
          v-model="queryForm.matchId"
          placeholder="ID精确搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item label="赛事名称">
        <el-input
          v-model="queryForm.titleKeyword"
          placeholder="名称模糊搜索"
          clearable
          @keyup.enter.native="handleQuery"
        ></el-input>
      </el-form-item>
      <el-form-item label="赛事状态">
        <el-select v-model="queryForm.status" clearable placeholder="全部">
          <el-option
            v-for="opt in competitionListStatusOptions"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetQuery">重置</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表区域 -->
    <div class="pagination">
      <el-button type="primary" size="small" @click="handleAdd"
        >增加赛事</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="tableData"
      border
      style="width: 100%"
      @sort-change="handleSortChange"
    >
      <el-table-column
        prop="id"
        label="赛事ID"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="赛事标题"
        align="center"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="报名时间" align="center" width="200">
        <template scope="{ row }">
          <span>{{ row.signStartTime }} — {{ row.signEndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="比赛时间" align="center" width="200">
        <template scope="{ row }">
          <span>{{ row.matchStartTime }} — {{ row.matchEndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="赛事状态" align="center" width="96">
        <template scope="{ row }">
          <span :class="statusClass(row.status)">{{
            statusText(row.status)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="viewCount"
        label="浏览人数"
        align="center"
        min-width="120"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="shareCount"
        label="分享人数"
        align="center"
        min-width="120"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="signUpCount"
        label="实际报名人数"
        align="center"
        min-width="120"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        prop="virtualParticipantInitCount"
        label="初始虚拟人数"
        align="center"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="virtualParticipantMultiplier"
        label="虚拟倍数"
        align="center"
        min-width="120"
        sortable="custom"
      >
        <template scope="{ row }">
          <span>{{
            +(+row.virtualParticipantMultiplier / 100).toFixed(2)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="displayRegisterCount"
        label="显示总人数"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="income"
        label="赛事收入"
        align="center"
        min-width="130"
        sortable="custom"
      >
        <template scope="{ row }">
          <span>{{ row.income }}元</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
        min-width="165"
        sortable="custom"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="340">
        <template scope="{ row }">
          <!-- 未发布（status=0 或 5仅预览）：只能编辑和预览 -->
          <template v-if="row.status === 0 || row.status === 5">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" @click="handlePreview(row)">预览</el-button>
          </template>
          <!-- 已发布等其他状态：只能查看详情，不能编辑 -->
          <template v-else>
            <el-button
              v-if="row.status === 2 || row.status === 1"
              type="text"
              @click="handleEdit(row, row.status === 2 ? '-1' : '')"
              >编辑</el-button
            >
            <el-button type="text" @click="handleDetail(row)"
              >查看详情</el-button
            >
            <el-button type="text" @click="handleInventory(row)"
              >查看库存</el-button
            >
            <el-button type="text" @click="handlePrizeRecord(row)"
              >奖品记录</el-button
            >
            <el-button type="text" @click="handleSignUpRecord(row)"
              >报名记录</el-button
            >
            <el-button type="text" @click="handleCopyLink(row)"
              >复制链接</el-button
            >
            <el-button type="text" @click="handleCopyMatch(row)"
              >复制赛事</el-button
            >
            <el-button type="text" @click="handleConfigVirtual(row)"
              >配置虚拟人数</el-button
            >
            <el-button
              type="text"
              @click="handleOffline(row)"
              v-if="row.status !== 4"
              >下架</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="queryForm.pageNum"
      :page-size="queryForm.pageSize"
      layout="prev, pager, next, jumper"
      :total="tableTotal"
      @current-change="handleCurrentChange"
    ></el-pagination>

    <!-- 预览链接弹框 -->
    <el-dialog
      custom-class="preview-link-dialog"
      v-model="previewDialogVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <template slot="title">
        <span class="preview-link-dialog__title">赛事预览链接</span>
      </template>
      <div class="preview-link-content">
        <p class="preview-link-desc">复制链接，在手机浏览器打开查看H5详情页</p>
        <div class="preview-link-row">
          <el-input
            v-model="previewUrl"
            readonly
            class="preview-link-input"
          ></el-input>
          <el-button class="preview-copy-btn" @click="copyPreviewUrl"
            >复制</el-button
          >
        </div>
        <p class="preview-link-tip">
          提示：预览链接仅用于核对页面，无法进行报名操作
        </p>
      </div>
      <template #footer>
        <el-button @click="previewDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="publishConfirmVisible = true"
          >正式发布</el-button
        >
      </template>
    </el-dialog>

    <!-- 正式发布确认弹框 -->
    <el-dialog
      custom-class="publish-confirm-dialog"
      v-model="publishConfirmVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <template slot="title">
        <span class="publish-confirm-dialog__title">正式发布确认</span>
      </template>
      <div class="publish-confirm-content">
        <p class="publish-confirm-desc">
          确认正式发布该赛事？发布后将同步到APP端，所有用户可见并可报名。
        </p>
      </div>
      <template #footer>
        <el-button @click="publishConfirmVisible = false">取消</el-button>
        <el-button type="primary" @click="handlePublish">确定发布</el-button>
      </template>
    </el-dialog>

    <!-- 查看库存弹框 -->
    <inventory-dialog
      :visible.sync="inventoryDialogVisible"
      :match-id="inventoryMatchId"
    ></inventory-dialog>

    <el-dialog
      custom-class="offline-confirm-dialog"
      v-model="offlineDialogVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <template slot="title">
        <span class="offline-confirm-dialog__title">下架确认</span>
      </template>
      <div class="offline-dialog-content offline-dialog-content--fit">
        <p class="offline-title">确认下架该赛事吗？</p>
        <div class="offline-rules">
          <p>1. 前台将隐藏赛事，不再接受新用户报名</p>
          <p>2. 已报名用户不受影响，可正常完赛、领取奖励</p>
          <p>3. 正式H5链接仍可访问，但无法报名</p>
        </div>
      </div>
      <template #footer>
        <el-button @click="offlineDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmOffline">确定</el-button>
      </template>
    </el-dialog>

    <!-- 配置虚拟人数比例弹框 -->
    <el-dialog
      custom-class="virtual-count-dialog"
      v-model="virtualDialogVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <template slot="title">
        <span class="virtual-count-dialog__title">配置虚拟人数比例</span>
      </template>
      <div class="virtual-count-content">
        <div class="virtual-count-row" style="margin-bottom: 20px">
          <span class="virtual-count-label">初始虚拟人数：</span>
          <el-input
            v-model="virtualParticipantInitCount"
            placeholder="填写基础虚拟人数"
            class="virtual-count-input"
            @change="filterVirtualInitCount"
          ></el-input>
        </div>
      </div>
      <div class="virtual-count-content">
        <div class="virtual-count-row">
          <span class="virtual-count-label">显示人数倍数：</span>
          <el-input
            v-model="virtualMultiple"
            placeholder="建议1-5倍"
            class="virtual-count-input"
          ></el-input>
        </div>
        <p class="virtual-count-tip">
          *设置后，显示报名人数=初始虚拟人数 + 实际报名人数*倍数
        </p>
      </div>
      <template #footer>
        <el-button @click="virtualDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="virtualSaving"
          @click="saveVirtualConfig"
          >保存配置</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import InventoryDialog from "./InventoryDialog.vue";

const LOG_TAG = "[赛事管理]";

/** 与 AdminCompetitionListReq.status 一致：赛事状态筛选 */
const COMPETITION_LIST_STATUS_OPTIONS = [
  { value: 0, label: "未发布" },
  { value: 1, label: "未开始" },
  { value: 2, label: "进行中" },
  { value: 3, label: "已结束" },
  { value: 4, label: "已下架" },
];

/** 列表排序：与 AdminCompetitionListReq.sortField 一致（POST /adminapi/competition/list） */
const SORT_COLUMN_PAYLOAD = {
  viewCount: "viewCount",
  shareCount: "shareCount",
  signUpCount: "registerCount",
  income: "revenue",
  createTime: "createTime",
};

export default {
  name: "matchManage",
  components: { InventoryDialog },
  data() {
    return {
      competitionListStatusOptions: COMPETITION_LIST_STATUS_OPTIONS,
      queryForm: {
        matchId: "",
        titleKeyword: "",
        status: null,
        pageNum: 1,
        pageSize: 10,
      },
      tableData: [],
      tableTotal: 0,
      menuSwitch: false,
      menuSwitchLoading: false,
      offlineDialogVisible: false,
      virtualDialogVisible: false,
      virtualRow: null,
      virtualMultiple: "",
      virtualParticipantInitCount: "",
      virtualSaving: false,
      previewDialogVisible: false,
      publishConfirmVisible: false,
      previewUrl: "",
      currentRow: null,
      listLoading: false,
      inventoryDialogVisible: false,
      inventoryMatchId: null,
      /** 与列 prop 一致；null 表示不按这些字段排序（同用户列表 sortable="custom"） */
      sortColumn: null,
      sortOrder: "desc",
    };
  },
  mounted() {
    this.fetchMenuSwitch();
    this.handleQuery();
  },
  methods: {
    /** 表头排序三角：与 CommunityUserListing 一致，sortable="custom" + sort-change */
    handleSortChange(sortInfo) {
      if (!sortInfo || !sortInfo.prop || !sortInfo.order) {
        this.sortColumn = null;
        this.sortOrder = "desc";
      } else {
        this.sortColumn = sortInfo.prop;
        this.sortOrder = sortInfo.order === "ascending" ? "asc" : "desc";
      }
      this.queryForm.pageNum = 1;
      this.fetchList();
    },
    isApiSuccess(errorCode) {
      return errorCode === 10000;
    },
    /** 列表行：接口字段 → 表格沿用字段名 */
    mapListRow(row) {
      if (!row) return row;
      return {
        ...row,
        id: row.competitionId,
        signStartTime: row.registrationStartTime || "",
        signEndTime: row.registrationEndTime || "",
        matchStartTime: row.startTime || "",
        matchEndTime: row.endTime || "",
        signUpCount: row.registerCount,
        income: row.revenue,
        status: row.displayStatus,
      };
    },
    statusText(displayStatus) {
      const map = {
        0: "未发布",
        1: "未开始",
        2: "进行中",
        3: "已结束",
        4: "已下架",
        5: "未发布",
      };
      return map[displayStatus] !== undefined ? map[displayStatus] : "未知";
    },
    statusClass(displayStatus) {
      const map = {
        0: "status-draft",
        1: "status-pending",
        2: "status-ongoing",
        3: "status-ended",
        4: "status-offline",
        5: "status-preview",
      };
      return map[displayStatus] || "";
    },
    handleQuery() {
      this.queryForm.pageNum = 1;
      this.fetchList();
    },
    fetchList() {
      const payload = {
        pageNum: this.queryForm.pageNum,
        pageSize: this.queryForm.pageSize,
      };
      const titleKw = (this.queryForm.titleKeyword || "").trim();
      if (titleKw) {
        payload.title = titleKw;
      }
      const matchId = (this.queryForm.matchId || "").trim();
      if (matchId && /^\d+$/.test(matchId)) {
        payload.competitionId = Number(matchId);
      }
      const st = this.queryForm.status;
      if (st !== "" && st !== null && st !== undefined) {
        payload.status = Number(st);
      }
      if (this.sortColumn && SORT_COLUMN_PAYLOAD[this.sortColumn]) {
        payload.sortField = SORT_COLUMN_PAYLOAD[this.sortColumn];
        payload.sortOrder = this.sortOrder;
      }

      this.listLoading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/competition/list",
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "list fail", body);
            this.$util.errorMsg(body.message || body.msg || "查询失败");
            this.tableTotal = 0;
            this.tableData = [];
            return;
          }
          const data = body.data || {};
          const list = data.list || [];
          this.tableTotal = data.total != null ? data.total : 0;
          this.tableData = list.map((r) => this.mapListRow(r));
        })
        .catch((err) => {
          console.warn(LOG_TAG, "list error", err);
          this.tableTotal = 0;
          this.tableData = [];
          this.$util.errorMsg("网络异常，请稍后重试");
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    resetQuery() {
      this.queryForm = {
        matchId: "",
        titleKeyword: "",
        status: null,
        pageNum: 1,
        pageSize: 10,
      };
      this.sortColumn = null;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.fetchList();
    },
    handleAdd() {
      this.$router.push({
        path: "/yunying/onlineMatch/matchDetail",
        query: { type: "add" },
      });
    },
    handleEdit(row, type = "") {
      this.$router.push({
        path: "/yunying/onlineMatch/matchDetail",
        query: { id: row.id, type: "edit" + (type || "") },
      });
    },
    handlePreview(row) {
      this.currentRow = row;
      this.previewUrl =
        this.$util.h5EventHost + "?competitionId=" + row.id + "&preview=1";
      this.previewDialogVisible = true;
    },
    copyPreviewUrl() {
      this.copyToClipboard(this.previewUrl);
    },
    handlePublish() {
      const row = this.currentRow;
      if (!row || row.id == null) {
        this.previewDialogVisible = false;
        return;
      }
      this.$http({
        url: this.$util.domain + "/adminapi/competition/publish",
        method: "POST",
        body: JSON.stringify({ id: row.id }),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "publish fail", body);
            this.$util.errorMsg(body.message || body.msg || "发布失败");
            return;
          }
          console.log(LOG_TAG, "正式发布成功", row.id);
          this.$message.success("发布成功");
          this.publishConfirmVisible = false;
          this.previewDialogVisible = false;
          this.currentRow = null;
          this.fetchList();
        })
        .catch((err) => {
          console.warn(LOG_TAG, "publish error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/yunying/onlineMatch/matchDetail",
        query: { id: row.id, type: "detail" },
      });
    },
    handleInventory(row) {
      this.inventoryMatchId = row.id;
      this.inventoryDialogVisible = true;
    },
    handlePrizeRecord(row) {
      this.$router.push({
        path: "/yunying/onlineMatch/signUpManage",
        query: { matchId: row.id, tab: "prize" },
      });
    },
    handleSignUpRecord(row) {
      this.$router.push({
        path: "/yunying/onlineMatch/signUpManage",
        query: { matchId: row.id, tab: "signup" },
      });
    },
    handleCopyLink(row) {
      const link =
        this.$util.h5EventHost + "?competitionId=" + row.id + "&preview=1";
      this.copyToClipboard(link);
    },
    handleCopyMatch(row) {
      if (!row || row.id == null) return;
      this.$http({
        url: this.$util.domain + "/adminapi/competition/copy",
        method: "POST",
        body: JSON.stringify({ id: row.id }),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "copy fail", body);
            this.$util.errorMsg(body.message || body.msg || "复制失败");
            return;
          }
          const data = body.data || {};
          // 清空需要用户手动填写的基础信息字段
          const copyData = Object.assign({}, data, {
            title: "",
            registrationStartTime: "",
            registrationEndTime: "",
            startTime: "",
            endTime: "",
          });
          try {
            sessionStorage.setItem("copyMatchData", JSON.stringify(copyData));
          } catch (e) {
            console.warn(LOG_TAG, "sessionStorage write fail", e);
          }
          console.log(LOG_TAG, "复制赛事数据已写入 sessionStorage，跳转创建页");
          this.$router.push({
            path: "/yunying/onlineMatch/matchDetail",
            query: { type: "copy" },
          });
        })
        .catch((err) => {
          console.warn(LOG_TAG, "copy error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        });
    },
    /** 列表 virtualParticipantMultiplier 为整数（倍数×100），还原成界面倍数文本 */
    multiplierFromStored(stored) {
      const n = Number(stored);
      if (!n || n <= 0) return "";
      const val = n / 100;
      return String(parseFloat(val.toFixed(2)));
    },
    handleConfigVirtual(row) {
      if (!row || row.id == null) return;
      this.virtualRow = row;
      // 每次点击都把列表中的 virtualParticipantMultiplier 带过来做回显
      this.virtualMultiple = this.multiplierFromStored(
        row.virtualParticipantMultiplier
      );
      this.virtualParticipantInitCount = row.virtualParticipantInitCount;
      this.virtualDialogVisible = true;
    },
    filterVirtualInitCount(val) {
      val = val.replace(/[^0-9]|e/g, "");
      if (val !== "") val = Math.round(val || 0);
      this.$nextTick(() => {
        this.virtualParticipantInitCount = val;
      });
    },
    saveVirtualConfig() {
      const val = (this.virtualMultiple || "").trim();
      if (!val) {
        this.$util.errorMsg("请输入显示人数倍数");
        return;
      }
      if (!/^\d+(\.\d{1,2})?$/.test(val)) {
        this.$util.errorMsg("倍数需为大于0的数字，最多保留2位小数");
        return;
      }
      const num = Number(val);
      if (num <= 0) {
        this.$util.errorMsg("倍数需大于0");
        return;
      }
      const row = this.virtualRow;
      if (!row || row.id == null) {
        this.virtualDialogVisible = false;
        return;
      }
      // 后端 virtualParticipantMultiplier 为整数：展示倍数 = 该值 / 100
      // 例：界面输入 1.5 倍 → 传 150；输入 2 倍 → 传 200
      const payload = {
        competitionId: row.id,
        virtualParticipantMultiplier: Math.round(num * 100),
        virtualParticipantInitCount: this.virtualParticipantInitCount,
      };
      this.virtualSaving = true;
      this.$http({
        url:
          this.$util.domain + "/adminapi/competition/updateVirtualMultiplier",
        method: "POST",
        body: JSON.stringify(payload),
      })
        .then((res) => {
          const body = res.body || {};
          // 该接口示例成功码为 0（与 competition 模块其他接口 10000 并存），兼容判断
          if (body.error === 10000 || body.error === 0) {
            this.$message.success("配置成功");
            this.virtualDialogVisible = false;
            this.virtualRow = null;
            this.virtualMultiple = "";
            // 保存后刷新列表，回显最新的 virtualParticipantMultiplier
            this.fetchList();
          } else {
            console.warn(LOG_TAG, "updateVirtualMultiplier fail", body);
            this.$util.errorMsg(body.message || body.msg || "配置失败");
          }
        })
        .catch((err) => {
          console.warn(LOG_TAG, "updateVirtualMultiplier error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        })
        .finally(() => {
          this.virtualSaving = false;
        });
    },
    handleOffline(row) {
      this.currentRow = row;
      this.offlineDialogVisible = true;
    },
    confirmOffline() {
      const row = this.currentRow;
      if (!row || row.id == null) {
        this.offlineDialogVisible = false;
        return;
      }
      this.$http({
        url: this.$util.domain + "/adminapi/competition/offline",
        method: "POST",
        body: JSON.stringify({ id: row.id }),
      })
        .then((res) => {
          const body = res.body || {};
          if (!this.isApiSuccess(body.error)) {
            console.warn(LOG_TAG, "offline fail", body);
            this.$util.errorMsg(body.message || body.msg || "下架失败");
            return;
          }
          this.$message.success("下架成功");
          this.offlineDialogVisible = false;
          this.currentRow = null;
          this.fetchList();
        })
        .catch((err) => {
          console.warn(LOG_TAG, "offline error", err);
          this.$util.errorMsg("网络异常，请稍后重试");
        });
    },
    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$message.success("链接已复制到剪贴板");
      } catch (e) {
        this.$message.error("复制失败，请手动复制");
      }
      document.body.removeChild(textarea);
    },
    fetchMenuSwitch() {
      this.$http({
        url: this.$util.domain + "/adminapi/competition/switch/detail",
        method: "GET",
      })
        .then((res) => {
          const body = res.body || {};
          if (this.isApiSuccess(body.error)) {
            this.menuSwitch = !!body.data;
            console.log(LOG_TAG, "获取赛事开关状态", this.menuSwitch);
          } else {
            console.warn(LOG_TAG, "获取赛事开关状态失败", body);
          }
        })
        .catch((err) => {
          console.warn(LOG_TAG, "获取赛事开关状态异常", err);
        });
    },
    handleMenuSwitchChange(val) {
      if (this.menuSwitchLoading) return;
      const statusText = val ? "开启" : "关闭";
      this.$confirm(`确认${statusText}赛事菜单展示吗？`, "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.menuSwitchLoading = true;
          this.$http({
            url: this.$util.domain + "/adminapi/competition/switch",
            method: "POST",
            body: JSON.stringify({ status: val }),
          })
            .then((res) => {
              const body = res.body || {};
              if (!this.isApiSuccess(body.error)) {
                console.warn(LOG_TAG, "switch fail", body);
                this.$util.errorMsg(body.message || body.msg || "操作失败");
                this.menuSwitch = !val;
                return;
              }
              this.menuSwitch = val;
              console.log(LOG_TAG, "赛事开关已" + statusText, this.menuSwitch);
              this.$message.success(`赛事菜单已${statusText}`);
            })
            .catch((err) => {
              console.warn(LOG_TAG, "switch error", err);
              this.$util.errorMsg("网络异常，请稍后重试");
              this.menuSwitch = !val;
            })
            .finally(() => {
              this.menuSwitchLoading = false;
            });
        })
        .catch(() => {
          this.menuSwitch = !val;
        });
    },
  },
};
</script>

<style scoped>
.match-manage {
  padding: 20px;
}
/* 固定高度 + 标题单独一行高，避免 inline/flex 基线导致「赛事管理」视觉上偏上 */
.page-header {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: space-between;
  height: 56px;
  margin-bottom: 20px;
  padding: 0 16px;
  background-color: #f5f7fa;
  box-sizing: border-box;
}
.page-header__title {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 18px;
  font-weight: bold;
  line-height: 56px;
  height: 56px;
  overflow: hidden;
}
.page-header__toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  height: 56px;
}
.page-header .menu-switch {
  vertical-align: middle;
}
.page-header .switch-text {
  font-size: 12px;
  color: #909399;
  font-weight: normal;
  line-height: 1.4;
}
.search-form {
  margin-bottom: 15px;
}
.pagination {
  margin-bottom: 15px;
}
.el-pagination {
  margin-top: 15px;
  text-align: right;
}
.status-draft {
  color: #909399;
}
.status-pending {
  color: #909399;
}
.status-signup {
  color: #e6a23c;
}
.status-ongoing {
  color: #67c23a;
}
.status-ended {
  color: #909399;
}
.status-offline {
  color: #f56c6c;
}
.status-preview {
  color: #409eff;
}
.offline-dialog-content {
  font-size: 14px;
}
.offline-dialog-content .offline-title {
  font-size: 16px;
  font-weight: normal;
  color: #000000;
  margin: 0 0 2px;
}
.offline-dialog-content .offline-rules {
  color: #000000;
  font-weight: normal;
  font-size: 13px;
  line-height: 1.4;
  padding-left: 0;
}
.offline-dialog-content .offline-rules p {
  margin: 0;
}
</style>

<style>
/* ---- 预览链接弹框 ---- */
.el-dialog.preview-link-dialog {
  width: 480px !important;
  max-width: calc(100vw - 48px) !important;
  box-sizing: border-box;
}
.el-dialog.preview-link-dialog .el-dialog__header {
  padding: 30px 32px 10px !important;
}
.el-dialog.preview-link-dialog .el-dialog__body {
  padding: 0 32px 10px !important;
}
.el-dialog.preview-link-dialog .el-dialog__footer {
  padding: 16px 32px 24px !important;
  text-align: right !important;
}
.el-dialog.preview-link-dialog .el-dialog__headerbtn,
.el-dialog.preview-link-dialog .el-dialog__close {
  display: none !important;
}
.preview-link-dialog__title {
  color: #000000 !important;
  font-weight: bold;
  font-size: 16px;
}
.preview-link-content .preview-link-desc {
  margin: 0 0 14px;
  font-size: 14px;
  color: #606266;
}
.preview-link-content .preview-link-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.preview-link-content .preview-link-input {
  flex: 1;
}
.preview-link-content .preview-copy-btn {
  flex-shrink: 0;
}
.preview-link-content .preview-link-tip {
  margin: 10px 0 0;
  font-size: 13px;
  color: #f56c6c;
}

/* el-dialog 常挂在 body，scoped 无法命中；与 index.css 里 dialog-wrapper 同理用全局类覆盖 */
.el-dialog.offline-confirm-dialog {
  width: auto !important;
  max-width: calc(100vw - 48px) !important;
  box-sizing: border-box;
  text-align: left !important;
}
.el-dialog.offline-confirm-dialog .offline-dialog-content--fit {
  width: max-content;
  max-width: calc(100vw - 80px);
  box-sizing: content-box;
  padding-left: 0;
  padding-right: 0;
  text-align: left;
}
.offline-confirm-dialog__title {
  color: #000000 !important;
  font-weight: bold;
  font-size: 16px;
}
.el-dialog.offline-confirm-dialog .el-dialog__header {
  padding: 38px 41px 12px !important;
  text-align: left !important;
}
.el-dialog.offline-confirm-dialog .el-dialog__headerbtn,
.el-dialog.offline-confirm-dialog .el-dialog__close {
  display: none !important;
}
.el-dialog.offline-confirm-dialog .el-dialog__body {
  padding: 0 41px 6px !important;
  text-align: left !important;
}
.el-dialog.offline-confirm-dialog .el-dialog__footer {
  padding: 18px 42px 22px !important;
  text-align: center !important;
}

/* ---- 正式发布确认弹框 ---- */
.el-dialog.publish-confirm-dialog {
  width: 400px !important;
  max-width: calc(100vw - 48px) !important;
  box-sizing: border-box;
}
.el-dialog.publish-confirm-dialog .el-dialog__header {
  padding: 30px 32px 10px !important;
}
.el-dialog.publish-confirm-dialog .el-dialog__headerbtn,
.el-dialog.publish-confirm-dialog .el-dialog__close {
  display: none !important;
}
.el-dialog.publish-confirm-dialog .el-dialog__body {
  padding: 10px 32px 10px !important;
}
.el-dialog.publish-confirm-dialog .el-dialog__footer {
  padding: 16px 32px 24px !important;
  text-align: right !important;
}
.publish-confirm-dialog__title {
  color: #000000 !important;
  font-weight: bold;
  font-size: 16px;
}
.publish-confirm-content .publish-confirm-desc {
  margin: 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

/* ---- 配置虚拟人数比例弹框 ---- */
.el-dialog.virtual-count-dialog {
  width: 420px !important;
  max-width: calc(100vw - 48px) !important;
  box-sizing: border-box;
}
.el-dialog.virtual-count-dialog .el-dialog__header {
  padding: 30px 32px 10px !important;
}
.el-dialog.virtual-count-dialog .el-dialog__headerbtn,
.el-dialog.virtual-count-dialog .el-dialog__close {
  display: none !important;
}
.el-dialog.virtual-count-dialog .el-dialog__body {
  padding: 10px 32px 4px !important;
}
.el-dialog.virtual-count-dialog .el-dialog__footer {
  padding: 16px 32px 24px !important;
  text-align: right !important;
}
.virtual-count-dialog__title {
  color: #000000 !important;
  font-weight: bold;
  font-size: 16px;
}
.virtual-count-content .virtual-count-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.virtual-count-content .virtual-count-label {
  flex-shrink: 0;
  font-size: 14px;
  color: #606266;
}
.virtual-count-content .virtual-count-input {
  width: 200px;
}
.virtual-count-content .virtual-count-tip {
  margin: 12px 0 0;
  font-size: 13px;
  color: #f56c6c;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// matchManage.vue?1067a8f4